export function visibleSwiper() {
  const slides = document.querySelectorAll(".testemunhos .swiper-slide");

  // Executa a lógica inicialmente
  slides.forEach((el) => {
    if (el.className.trim() === "swiper-slide") {
      el.style.opacity = 0;
    }
  });

  // Cria o observer
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        const el = mutation.target;
        if (el.className.trim() === "swiper-slide") {
          el.style.opacity = 0;
        } else {
          el.style.opacity = 1;
        }
      }
    }
  });

  // Observa cada .swiper-slide individualmente
  slides.forEach((el) => {
    observer.observe(el, { attributes: true, attributeFilter: ["class"] });
  });
}
